export default "__VITE_ASSET__DKtrbkDF__"